"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetShipmentInfosTypeEnum = exports.GetBookingsTypeEnum = exports.AccountApi = void 0;
var runtime = __importStar(require("../runtime"));
var models_1 = require("../models");
/**
 *
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountApi.prototype.buildUrl = function (path, queryParameters) {
        var query = this.configuration.queryParamsStringify(queryParameters);
        return "".concat(this.configuration.basePath).concat(path).concat(query && "?".concat(query));
    };
    AccountApi.prototype.getInternalCallInfoForCancelOrderDetail = function (requestParameters) {
        if (requestParameters.orderDetailId === null || requestParameters.orderDetailId === undefined) {
            throw new runtime.RequiredError('orderDetailId', 'Required parameter requestParameters.orderDetailId was null or undefined when calling cancelOrderDetail.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/orderdetail/{orderDetailId}".replace("{".concat("orderDetailId", "}"), encodeURIComponent(String(requestParameters.orderDetailId)))
        };
    };
    AccountApi.prototype.getUrlForCancelOrderDetailByDELETE = function (requestParameters) {
        var _a = this.getInternalCallInfoForCancelOrderDetail(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * cancel a specific order detail
     */
    AccountApi.prototype.cancelOrderDetailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForCancelOrderDetail(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GenericSuccessResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * cancel a specific order detail
     */
    AccountApi.prototype.cancelOrderDetail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelOrderDetailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForDeclareReturns = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/returndeclaration"
        };
    };
    AccountApi.prototype.getUrlForDeclareReturnsByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForDeclareReturns(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Submit tracking data of returned items
     */
    AccountApi.prototype.declareReturnsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDeclareReturns(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ReturnDeclarationRequestPayloadToJSON)(requestParameters.returnDeclarationRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ReturnDeclarationResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Submit tracking data of returned items
     */
    AccountApi.prototype.declareReturns = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.declareReturnsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetBankStatementDocument = function (requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getBankStatementDocument.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/bank-statements/{id}/document.pdf".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id)))
        };
    };
    AccountApi.prototype.getUrlForGetBankStatementDocumentByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetBankStatementDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * download the bank statement as a pdf document
     */
    AccountApi.prototype.getBankStatementDocumentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetBankStatementDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * download the bank statement as a pdf document
     */
    AccountApi.prototype.getBankStatementDocument = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBankStatementDocumentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetBankStatements = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/bank-statements"
        };
    };
    AccountApi.prototype.getUrlForGetBankStatementsByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetBankStatements(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get the bank statements of the current user
     */
    AccountApi.prototype.getBankStatementsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetBankStatements(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.BankstatementsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the bank statements of the current user
     */
    AccountApi.prototype.getBankStatements = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBankStatementsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetBookingImages = function (requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getBookingImages.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/bookings/images/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id)))
        };
    };
    AccountApi.prototype.getUrlForGetBookingImagesByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetBookingImages(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get product images for a selected booking entry
     */
    AccountApi.prototype.getBookingImagesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetBookingImages(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ImageListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get product images for a selected booking entry
     */
    AccountApi.prototype.getBookingImages = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingImagesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetBookings = function (requestParameters) {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getBookings.');
        }
        var queryParameters = {};
        if (requestParameters.days !== undefined) {
            queryParameters['days'] = requestParameters.days;
        }
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        return {
            queryParameters: queryParameters,
            path: "/bookings/{type}".replace("{".concat("type", "}"), encodeURIComponent(String(requestParameters.type)))
        };
    };
    AccountApi.prototype.getUrlForGetBookingsByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetBookings(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get current customer\'s bookings
     */
    AccountApi.prototype.getBookingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetBookings(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.ecMobile !== undefined && requestParameters.ecMobile !== null) {
                            headerParameters['ec-mobile'] = String(requestParameters.ecMobile);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.BookingsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get current customer\'s bookings
     */
    AccountApi.prototype.getBookings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetDataExport = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/data-export"
        };
    };
    AccountApi.prototype.getUrlForGetDataExportByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetDataExport(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get the URL for getting the data export
     */
    AccountApi.prototype.getDataExportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetDataExport(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * get the URL for getting the data export
     */
    AccountApi.prototype.getDataExport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataExportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetInvoice = function (requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getInvoice.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/invoice/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id)))
        };
    };
    AccountApi.prototype.getUrlForGetInvoiceByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetInvoice(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get online invoice
     */
    AccountApi.prototype.getInvoiceRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetInvoice(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.InvoiceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get online invoice
     */
    AccountApi.prototype.getInvoice = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInvoiceRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetInvoiceDocument = function (requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getInvoiceDocument.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/invoice/{id}/document.pdf".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id)))
        };
    };
    AccountApi.prototype.getUrlForGetInvoiceDocumentByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetInvoiceDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * download the invoice as a pdf document
     */
    AccountApi.prototype.getInvoiceDocumentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetInvoiceDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * download the invoice as a pdf document
     */
    AccountApi.prototype.getInvoiceDocument = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInvoiceDocumentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetPaymentPlan = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/status/payment-plan"
        };
    };
    AccountApi.prototype.getUrlForGetPaymentPlanByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetPaymentPlan(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get customer\'s current maturities and payment status
     */
    AccountApi.prototype.getPaymentPlanRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetPaymentPlan(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.ecMobile !== undefined && requestParameters.ecMobile !== null) {
                            headerParameters['ec-mobile'] = String(requestParameters.ecMobile);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaymentPlanFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get customer\'s current maturities and payment status
     */
    AccountApi.prototype.getPaymentPlan = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPaymentPlanRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetReturnLabelDocument = function (requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getReturnLabelDocument.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/return-label/{id}/document.pdf".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id)))
        };
    };
    AccountApi.prototype.getUrlForGetReturnLabelDocumentByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetReturnLabelDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * download the return label based on returnId as a pdf document
     */
    AccountApi.prototype.getReturnLabelDocumentRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetReturnLabelDocument(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * download the return label based on returnId as a pdf document
     */
    AccountApi.prototype.getReturnLabelDocument = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReturnLabelDocumentRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetReturnLabelQRCode = function (requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getReturnLabelQRCode.');
        }
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/return-label/{id}/qrcode".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id)))
        };
    };
    AccountApi.prototype.getUrlForGetReturnLabelQRCodeByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetReturnLabelQRCode(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get the qr code information
     */
    AccountApi.prototype.getReturnLabelQRCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetReturnLabelQRCode(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ReturnLabelQRCodeFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the qr code information
     */
    AccountApi.prototype.getReturnLabelQRCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReturnLabelQRCodeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForGetShipmentInfos = function (requestParameters) {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getShipmentInfos.');
        }
        var queryParameters = {};
        if (requestParameters.days !== undefined) {
            queryParameters['days'] = requestParameters.days;
        }
        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }
        return {
            queryParameters: queryParameters,
            path: "/shipment-infos/{type}".replace("{".concat("type", "}"), encodeURIComponent(String(requestParameters.type)))
        };
    };
    AccountApi.prototype.getUrlForGetShipmentInfosByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetShipmentInfos(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get customer\'s orders, deliveries, returns, ...
     */
    AccountApi.prototype.getShipmentInfosRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetShipmentInfos(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ShipmentInfosFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get customer\'s orders, deliveries, returns, ...
     */
    AccountApi.prototype.getShipmentInfos = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getShipmentInfosRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountApi.prototype.getInternalCallInfoForResolveTrackAndTraceUrl = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/tracking"
        };
    };
    AccountApi.prototype.getUrlForResolveTrackAndTraceUrlByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForResolveTrackAndTraceUrl(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * resolve a pseudo url to a real track \'n trace url
     */
    AccountApi.prototype.resolveTrackAndTraceUrlRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForResolveTrackAndTraceUrl(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.UrlContainerToJSON)(requestParameters.urlContainer),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UrlContainerFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * resolve a pseudo url to a real track \'n trace url
     */
    AccountApi.prototype.resolveTrackAndTraceUrl = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveTrackAndTraceUrlRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AccountApi;
}(runtime.BaseAPI));
exports.AccountApi = AccountApi;
/**
    * @export
    * @enum {string}
    */
var GetBookingsTypeEnum;
(function (GetBookingsTypeEnum) {
    GetBookingsTypeEnum["All"] = "all";
    GetBookingsTypeEnum["Invoice"] = "invoice";
    GetBookingsTypeEnum["Payment"] = "payment";
    GetBookingsTypeEnum["Reimbursement"] = "reimbursement";
})(GetBookingsTypeEnum = exports.GetBookingsTypeEnum || (exports.GetBookingsTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetShipmentInfosTypeEnum;
(function (GetShipmentInfosTypeEnum) {
    GetShipmentInfosTypeEnum["All"] = "all";
    GetShipmentInfosTypeEnum["Ordered"] = "ordered";
    GetShipmentInfosTypeEnum["Sent"] = "sent";
    GetShipmentInfosTypeEnum["Delivery"] = "delivery";
    GetShipmentInfosTypeEnum["Delivered"] = "delivered";
    GetShipmentInfosTypeEnum["Returned"] = "returned";
    GetShipmentInfosTypeEnum["Canceled"] = "canceled";
})(GetShipmentInfosTypeEnum = exports.GetShipmentInfosTypeEnum || (exports.GetShipmentInfosTypeEnum = {}));
//# sourceMappingURL=AccountApi.js.map